var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0832 3.33301H7.9165L5.83317 5.83301H3.33317C2.89114 5.83301 2.46722 6.0086 2.15466 6.32116C1.8421 6.63372 1.6665 7.05765 1.6665 7.49967V14.9997C1.6665 15.4417 1.8421 15.8656 2.15466 16.1782C2.46722 16.4907 2.89114 16.6663 3.33317 16.6663H16.6665C17.1085 16.6663 17.5325 16.4907 17.845 16.1782C18.1576 15.8656 18.3332 15.4417 18.3332 14.9997V7.49967C18.3332 7.05765 18.1576 6.63372 17.845 6.32116C17.5325 6.0086 17.1085 5.83301 16.6665 5.83301H14.1665L12.0832 3.33301Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 13.333C11.3807 13.333 12.5 12.2137 12.5 10.833C12.5 9.4523 11.3807 8.33301 10 8.33301C8.61929 8.33301 7.5 9.4523 7.5 10.833C7.5 12.2137 8.61929 13.333 10 13.333Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoto);
export default __webpack_public_path__ + "static/media/photo.dd7edb0474891fb7a0206d5b2a3dfcf8.svg";
export { ForwardRef as ReactComponent };